import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import { getIntereses, guardarIntereses } from "../api";
import { toast } from "react-hot-toast";
import { motion } from "framer-motion";
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const Intereses = () => {
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const showSplash = useDynamicSplash(loading);
  const [seleccionados, setSeleccionados] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategorias = async () => {
      try {
        setLoading(true);
        document.body.style.overflow = "hidden";
        const data = await getIntereses();
        setCategorias(data.categorias || []);
        window.scrollTo(0, 0);
      } catch (error) {
        toast.dismiss();
        toast.error("Error al cargar intereses");
      } finally {
        setLoading(false);
        document.body.style.overflow = "auto";
      }
    };
    fetchCategorias();
  }, []);

  const toggleInteres = (id) => {
    if (seleccionados.includes(id)) {
      setSeleccionados(seleccionados.filter((item) => item !== id));
    } else {
      setSeleccionados([...seleccionados, id]);
    }
  };

  const handleGuardar = async () => {
    if (seleccionados.length < 3) {
      toast.dismiss();
      toast.error("Elige al menos 3 intereses");
      return;
    }

    try {
      const id_perfil = localStorage.getItem("id_perfil");
      const result = await guardarIntereses(id_perfil, seleccionados);

      if (result.success) {
        toast.dismiss();
        toast.success("Intereses guardados exitosamente");
        navigate("/", { replace: true });
      } else {
        toast.dismiss();
        toast.error(result.error || "Error al guardar intereses");
      }
    } catch (err) {
      toast.dismiss();
      toast.error("Error inesperado al guardar");
    }
  };
  return (
    <>
      {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}
      {!showSplash && (
       <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
    <div className="app-container cmpd">
      <div className="connections-container">
        <h2 className="connections-title">Selecciona tus intereses</h2>
      </div>
      <p className="mb-4 text-center">
        Elige al menos 3 intereses para brindarte recomendaciones personalizadas
      </p>
      <div className="interests-list">
        {categorias.map((cat) => (
          <div key={cat.id} className="interest-item">
            <input
              type="checkbox"
              id={`cat_${cat.id}`}
              className="interest-checkbox"
              checked={seleccionados.includes(cat.id)}
              onChange={() => toggleInteres(cat.id)}
            />
            <label htmlFor={`cat_${cat.id}`}>
                <img
                    src={cat.icono}
                    alt={cat.nombre}
                    onError={(e) => {
                      e.target.onerror = null; 
                      e.target.src = "/assets/images/default.png";
                    }}
                    style={{ width: 20, height: 20, marginRight: 8 }}
                />
                {cat.nombre}
            </label>
          </div>
        ))}
      </div>
      <button className="next-button mt-4" onClick={handleGuardar}>
        Guardar
      </button>
    </div>
    </motion.div>
    )}
    </>
  );
};

export default Intereses;
